<template>
  <div
    @click="$emit('add')"
    class="add-column-container py-4 px-3 d-flex justify-center align-center cursor-pointer blue-grey--text"
  >
    <v-icon class="mr-1" size="16" color="blue-grey"
      >mdi-plus-circle-outline</v-icon
    >
    {{ $t('boards.add_column') }}
  </div>
</template>

<script>
export default {
  name: 'AddColumnButton',
}
</script>

<style scoped lang="scss">
.add-column-container {
  border-radius: 4px;
  border: 1px dashed $color-blue-grey-lighten1;
}
</style>
